export const pt = {
    //Login
    loginTitle: 'Bem-vindo',
    loginMessage: 'Faça Login para Entrar',
    username: 'Username',
    email:'Email',
    password:'Password',
    newPassword:'Nova Password',
    repeatNewPassword:'Repete a Nova Password',
    authenticateUser:'Verificar Utilizador',
    recoverPassword:'Recuperar Password',
    recoverPasswordDescription:'Verifique o seu Email e siga as Instruções para Redifinir a Password',
    forgotPassword:'Esqueceu-se da Password',
    code:'Código',
    acceptWordOs:'Aceitar os',
    acceptWordAs:'Aceitar as',
    termsConditions:'Termos e Condições',
    cookies:'Política de Cookies',
    privacyRule:'Aceitar a',
    privacyRuleLink:'confidencialidade de Dados',
    repeatPasswordLabel:'Repita a Password Utilizada acima',
    inputLabelNewPassword:'A Password deve Respeitar os Requisitos',
    logout:'Terminar Sessão',

    //---- Nav Bar Items-----
    inicio: 'Início',
        municipality: 'Município',
        territory: 'Território',
        autarchy: 'Autarquia',
        entity: 'Entidade',
        emissions:'Emissões de GEE no Território',

    map: 'Mapa',
        emissionsDistribution:'Emissões de GEE no Território',
        energyConsumption:'Consumo de Energia',
        flowchartEmissions:'Fluxograma das Emissões',
        generalIndicators: 'Indicadores Gerais',

    politicas: 'Políticas',
    events: 'Eventos',
    registry: 'Cadastro',
        registrationManagement:'Gestão de Cadastro',
        searchForAsset: 'Pesquisa por Instalações',
    searhForResource: 'Pesquisa por Código da Instalação',
        energy:'Energia',
    analytics: 'Analítica',
        timeLine:'Análise de Dados',
        filters:'Filtros',
        energyEmissions:'Energia e Emissões',
//---------
    contractsOfElectricitity: 'Contratos de Eletricidade',
    electricityConsumptionByType: 'Consumo de Eletricidade por Tipologia',
    gasContracts: 'Contratos de Gás',
    buildingsEvaluated:'Edifícios em Monitorização',
    installationsByVoltageLevel:'Instalações por Nível de Tensão',

    anualGasConsumption: 'Consumo Anual de Gás',
    accumulatedTooltip:'Valor acumulado no período selecionado',
    anualElectricityConsumption: 'Consumo Anual de Eletricidade',
    anualElectricityConsumptionTotal: 'Consumo Anual Acumulado de Eletricidade Total',
    anualElectricityConsumptionMtAtMat: 'Consumo Anual Acumulado de Eletricidade (MT+AT+MAT)',
    anualElectricityConsumptionBtnBte: 'Consumo Anual Acumulado de Eletricidade (BTN+BTE)',
    anualCO2Emissions:'Emissões Anuais de GEE',

    topConsumers:'Instalações com Maior Consumo',
    monthlyElectricityConsumption:'Consumo Mensal de Eletricidade',
    sectorCO2Emissions:'Emissões por Setor',
    sectorEnergyConsumption:'Consumo de Energia por Setor',
    cO2EmissionsEvolution:'Evolução das Emissões por Setor',
    emissionsScope:'Emissões por Âmbito',
    evolutionEmissionsScope:'Evolução das Emissões por Âmbito',
    evolutionBySector:'Evolução das Emissões por Setor',

    totalEnergyConsumption:'Evolução do Consumo Total de Energia',
    electricityConsumption:'Consumo de Eletricidade',
    gasConsumption:'Consumo de Gás',

    diagramSankey:'Diagrama de Sankey (tCO2eq)',
    loadDiagrams:'Diagramas de Carga',

    "Events Severity":'Eventos por Gravidade',
    critical:'Crítico',
    high:'Elevado',
    medium: 'Médio',
    low:'Baixo',
    others:'Outros',
    eventsMap:'Mapa de Eventos',
    eventDensity:'Densidade de Eventos',
    seeInfoEvents: 'Ver Eventos Informativos',
    territoryConsumptionDensity:'Densidade de Consumos no Território',
    "Show info": "Mostrar Info",
    "Severity": "Gravidade",
    "Open Date": "Data de início",
    "Class": "Classe",
    "Name": "Nome",
    "Description": "Descrição",
    "Category": "Categoria",

    exportToPdf: 'Exportar para PDF',
    exportsToCsv: 'Exportar para CSV',

    totalPowerInstalledQuarterConsumption:'Potência Total Instalada por Trimestre para Autoconsumo',
    totalPowerInstalledDescription:'Potência Total Instalada Acumulada por Trimestre - Total Municipal',

    usersList: 'Lista de Utilizadores',
    activePotency: 'Potencia Ativa',
    reactiveIndutivePotency: 'Potencia Reativa Indutiva',
    reactiveCapacitivePotency: 'Potencia Reativa Capacitiva',
    productionPotency:'Potencia de Produção',
    annualExportUnavailable: 'Não é Possível Exportar Dados para um Período Anual.',
    dataExportionForPeriod: 'Exportação para o Período Filtrado de ',
    totalEmissions: 'Emissões totais',
    resultingEnergyConsumption: 'Consumo de Energia Resultante',
    carbonCapture: 'Captura de Carbono',

    //Daily analisis
    activeEnergyAndProduction: 'Potência Ativa e Potência de Produção',
    indutiveAndCapacitiveEnergy: 'Potência Reativa Indutiva e Capacitiva',
    topEnergy:'Pico de Potência Ativa',
    inductiveConsumption: 'Consumo de Energia Indutiva',
    energyProduced: 'Energia Produzida (c/ % autoconsumo kWh)',
    activeConsumption: 'Consumo De Energia Ativa',
    capacitiveConsumption: 'Consumo de Energia Capacitiva',
    gridInjection: 'Injeção na rede',
    informationFromPreviousPeriod: 'Informação dos 31 dias anteriores',
    activePower: 'Potência Ativa',
    productionPower: 'Potência de Produção',
    inductivePower: 'Potência Reativa Indutiva',
    capacitivePower: 'Potência Reativa Capacitiva',
    highestRegistedPeak: 'Pico Máximo Registado',
    inductiveConsumption: 'Consumo de Energia Indutiva',
    activeConsumption: 'Consumo de Energia Ativa',
    capacitiveConsumption: 'Consumo de Energia Capacitiva',
    dailyPowerPeaks: 'Picos de Carga Diários',
    productionPeak: 'Pico de Produção',
    loadDiagrams: 'Diagrama de Cargas Diário',
    'Daily Analysis': 'Análise Diária',
    Historical: 'Histórico',

    //----- Buttons --------
    seeOnMap:'Ver no Mapa',
    delete:'Eliminar',
    add:'Adicionar',
    apply:'Aplicar',
    clear:'Limpar', 
    lines:'Linhas',
    bars:'Barras',
    heatmap:'HeatMap',
    report: 'Relatório',
    exportRawData:'Exportação de Dados',
    signIn:'Iniciar sessão',
    resetPassword:'Redifinir Password',
    sendEmail:'Enviar Email',
    edit:'Editar',
    submit:'Submeter',
    cancel:'Cancelar',
    save:'Guardar',
    seeDetail:'Ver Detalhe',
    upload:'Carregar',
    deleteDescription: 'Tem a Certeza que Pretende Apagar o Elemento?',
    //-------------------------------
    Energy: 'Energia',
    inductive:'Indutiva',
    capacitive:'Capacitiva',
    activeEnergy:'Energia Activa',
    energyProduced:'Energia produzida',
    inductiveEnergy:'Energia Indutiva',
    capacitiveEnergy:'Energia Capacitiva',
    reactiveEnergy:'Energia Reativa',
    powerCharges:'Encargos de Potência',
    inductiveReactiveEnergy:'Energia Reativa Indutiva',
    capacitiveReactiveEnergy:'Energia Reativa Capacitiva',
    activeEnergyConsumption:'Consumo de Energia Ativa',
    inductiveEnergyConsumption:'Consumo de Energia Indutiva',
    capacitiveEnergyConsumption:'Consumo de Energia Capacitiva',
    selfConsumption:'de Autoconsumo',
    emissionsAvoided:'Emissões Equivalentes Evitadas',
    averageConsumption:'Consumo Médio',
    maximumConsumption:'Consumo Máximo',
    averageConsumptionDaysOfWeek:'Consumo Médio Dias da Semana',
    daysOfWeek:'Dias da Semana',
    pickPower:'Pico de Potência',
    averagePower:'Potência Média',
    saturdayAndSunday:'Sábados e Domingos',
    consumption:'Consumos',
    fourHourly:'Tetra-horário',
    empty:'Vazio',
    full:'Cheio',
    edge:'Ponta',
    superEmpty:'Super Vazio',
    providedByTheGrid:'Fornecida pela Rede',
    injectedIntoTheGrip:'Injetada na Rede',
    fixedTariffTerm:'Termo Tarifário Fixo',
    contractedPower:'Potencia Contratada',
    powerPeakHours:'Potência em Horas de Ponta',
    finalCost:'Custo Final',
    associatedCO2Emissions:'Emissões GEE Associadas',
    imagesForReport: 'Imagens para Relatório',
	powerChanges:'Encargos de Potência',
    peakHours:'Horas de Ponta',
    noDataResource:'Sem Recursos Disponíveis',
    noData: 'Sem dados',
//------------
    search:'Pesquisar',
    selectPeriod:'Selecione o Periodo',
    eletricEnergy:'Energia Elétrica',
    production:'Produção',
    export:'Exportação',
    energeticCertification:'Certificação Energética',
    relatedAssets:'Ativos Relacionados',
    costEstimation:'Estimação de Custos',
    selectPotency: 'Selecione a Potência',
    searchByCPE: 'Pesquisa Por CPE',
    energyVector: 'Vetor Energético',
//------ Date Formats -----
    day:'dia',
    days:'Dias',
    week:'Semana',
    weeks:'Semanas',
    months:'Meses',
    year:'Ano',
    years:'Anos',
    hourly:'Horário',
    daily:'Diário',
    weekly:'Semanal',
    startDate:'Data início',
    endDate:'Data fim',
    annual: 'Anual',
    monthly:'Mensal',
    quarter:'Trimestral',
    yearly:'Anual',
    raw:'Bruto',

    jan: 'jan',
    feb: 'fev',
    mar: 'mar',
    apr: 'abr',
    may: 'mai',
    jun: 'jun',
    jul: 'jul',
    aug: 'ago',
    sep: 'set',
    oct: 'out',
    nov: 'nov',
    dec: 'dez',

    mon: 'seg',
    tue: 'ter',
    wed: 'qua',
    thu: 'qui',
    fri: 'sex',
    sat: 'sáb',
    sun: 'dom',
//------------
    data:'Dados',
    name:'Nome',

    simple: 'Simples',
    biHourly: 'Bi-horária',
    triHourly: 'Tri-horária',
    tetraHourly: 'Tetra-horária',

    page:'Página',
    seeMore:'Ver Mais',
    seeLess:'Ver Menos',

    simulatedTariffs: 'Tarifário Simulado',
//------------ Tooltips -----------
    passwordRequirements:'Requisitos da Password',
    minimunCharacters:'8 caracteres mínimos',
    numberCharacter: 'Conter pelo menos 1 número',
    uppercaseLetter: 'Conter pelo menos 1 letra maiúscula',
    lowercaseLetter: 'Conter pelo menos 1 letra minúscula',
    specialCharacter: 'Conter pelo menos 1 caracter especial',
    dataBasedEReded: 'Gerado com base nos dados mais recentes da Open Data da E-REDES',
    dataRefersToYear: "Dados referentes ao ano de ",
    comparingElectricityConsumption:'Comparando Consumos de Energia Elétrica',
    heatmapExplained:'Heatmap gerado com base nos consumos dos Postos de Transformação de Distribuição do Território',
    heatmapTooltip:'Heatmap apresenta a densidade do consumo elétrico no território',
    "BTN: Low Normal Voltage":"BTN: Baixa Tensão Normal",    
    "BTN-IP: Low Normal Voltage in Public Lighting":"BTN-IP: Baixa Tensão Normal na Iluminação Pública",
    "BTE: Special Low Voltage":"BTE: Baixa Tensão Especial",
    "MT: Medium Voltage":"MT: Média Tensão",
    "AT: High Voltage":"AT: Alta Tensão",

//------------ AuthContext Errors -----------
    incorrectFields: 'Username ou Password Incorreto',
    passwordNoMatch:'As Passwords não estão iguais',
    passwordNotValid:'Password não cumpre os requisitos',
    emailSentCode:'Email enviado com o código de verificação',
    codeSentByMessage:'Código mandado por mensagem',
    firstLogin:'Pimeiro Login, precisa de verificar a conta',
    errorResetPassword:'Algo correu mal, Por favor verifique o código ou os requisitos da password',
    infoDescription:'Não é possiível fazer exportação sem dados',

    error:'Erro',
    success:'Sucesso',
    warning:'Aviso',
    info:'Informação',

    successAdd: 'Elemento adicionado com sucesso.',
    errorAdd: 'Erro: item não adicionado.',

    successDelete: 'Elemento apagado com sucesso.',
    errorDelete: 'Erro: item não apagado.',

    errorGettingCertificates: 'Ocorreu um erro ao tesntar obter a lista de certificados.',

//--------------------- Forms -----------------
    phoneNumber:'Telemóvel',
    expirationDate:'Data de Validade',
    energyClass:'Classe Energética',

//--------------------- Tooltip ----------------------
    contractsOfElectricitityTooltip:'Total de ativos (incluindo Iluminação Pública) com registo de dados de eletricidade',
    gasContractsTooltip:'Total de instalações com registo de dados de gás',
    buildingsEvaluatedTooltip:'Total de instalações do tipo “Edifícios” com registo de dados',
    IPPUTooltip:'IPPU: Emissões associadas a processos industriais específicos ou a uso de produtos não-energéticos na indústria',
    AFOLUTooltip:'AFOLU: Emissões associadas ao uso do solo para efeitos agrícolas',
    mapOverlayTooltip:'Valor Acumulado de Consumos',
    searchResourceTooltip:'Pesquisa por CPE, CUI ou Inversor',
    estimatedValue:'Valor estimado que representa a capacidade do território de absorver Carbono',

    //--------------------- Filters -----------------
    filters: 'Filtros',
    rester: 'Limpar',
    savedFilters: 'Guardar filtros',
    apply: 'Aplicar',

    Buildings: 'Edifícios',
    Infrastructures: 'Infraestruturas',

    //Edifícios
    Others: 'Outros',
    Social: 'Social',
    'Social Housing': 'Habitação Social',
    'Sports': 'Desportivo',
    'Administrative': 'Administrativo',
    'Civil Protection': 'Proteção Civil',
    'Cultural Spaces': 'Espaço Cultural',
    'School': 'Escola',
    Health: 'Saude',
    Storage: 'Armazém',
    'Pavilion': 'Pavilhão',

    //Infraestruturas
    'Parking Lot': 'Parque de Estacionamento',
    'Street Lighting': 'Iluminação Pública',
    'Domestic Waste Collection': 'Recolha de Resíduos Domésticos',
    'Sanitary waste water collection': 'Recolha de Águas Residuais Sanitárias',
    'Tunnel': 'Túnel',
    'Graveyard': 'Cemitério',
    'Water Supply': 'Abastecimento de Água',
    'Electric Vehicle Charging Station': 'Estação de Carregamento de Veículos Eléctricos',
    'Road Segment': 'Segmento Rodoviário',
    'Energy Production': 'Produção de Energia',
    'Distribution Network': 'Rede de Distribuição',
    'Advertising Panels': 'Painel Publicitário',
    'Traffic Light': 'Semáforo',

    'Public Space': 'Espaço público',
    'Commercial': 'Comercial',
    'Monument': 'Monumento',

    //New Analytics Page
    'GEE Emissions':'Emissões de GEE',
    'Number of Installations':'Número de Instalações',
    'Total Consumption':'Consumo Total',
    'Cumulative analysis':'Análise cumulativa',
    'Comparative analysis':'Análise Comparativa',
    "Select periodicity":"Selecione periodicidade",
    "Select Metric/s":"Seleciona a Métrica/s",
    "Active Energy":"Energia Ativa",
    "Inductive Reactive Power":"Potência Reativa Indutiva",
    "Inductive Reactive Energy":"Energia Reativa Indutiva",
    "Capacitive Reactive Power":"Potência Reativa Capacitiva",
    "Capacitive Reactive Energy":"Energia Reativa Capacitiva",
    "Production":"Produção",
    'Active Power':'Potência Ativa',
    'Reactive Inductive Power': 'Potência Reativa Indutiva',
    'Reactive Capacitive Power': 'Potência Reativa Capacitiva',
    "Gas":"Gás",
    'Cumulative Analysis':'Análise Cumulativa',
    "Energy Certificate":"Certificado Energético",
    "GaS":"Gás",
    "Energy Production":"Produção de Energia",
    "Limit of 5 items":"Limite de 5 itens",
    "Total Accumulated":"Total Acumulado",
    "Typology":"Tipologia",
    "Address":"Morada",
    "Voltage Level":"Nível de Tensão",
    "Contracted Power":"Potência Contratada",
    "Municipality-Parish": "Concelho-Freguesia",
    "Max Allowed Power":"Potência Máxima Permitida",
    "Entity/Subentity": "Entidade/Subentidade",
    "Daily Average":"Média Diária",
    "Daily Peak":"Pico Diário",
    "Production Power":"Potência de Produção",
    "Inductive Power":"Potência Indutiva",
    "Capacitive Power":"Potência Capacitiva",
    "Consumed":"Consumo",
    "Produced":"Produção",
    "Event List":"Lista de Eventos",
    'Limit of 5 items':'Limite de 5 itens',
    "Distribution Transformer Stations":"Estações Transformadoras de Distribuição",
    "Facilities":"Instalações",
    "Top Consumers":"Top Consumidores",
    "Invalid POI position":"Posição do POI inválida",
    "The density map takes into account the longevity of the event": "O mapa de densidades tem em conta a longevidade do evento",
};